import { TinyColor } from '@ctrl/tinycolor';
import { TEXT_LINKS_AND_HASHTAGS_COLOR, TEXT_PARAGRAPH_COLOR, TEXT_QUOTE_COLOR, POST_BUTTON_TEXT_COLOR, TEXT_H1_COLOR, TEXT_H2_COLOR, TEXT_H3_COLOR, TEXT_H4_COLOR, TEXT_H5_COLOR, TEXT_H6_COLOR, } from '../../../constants';
import { getPresetColor, getStyleColor } from '../../../services/colors';
export const getTextColorSchema = ({ appSettings }) => {
    const colors = [
        getStyleColor(appSettings, TEXT_PARAGRAPH_COLOR),
        getStyleColor(appSettings, TEXT_QUOTE_COLOR),
        getStyleColor(appSettings, TEXT_LINKS_AND_HASHTAGS_COLOR),
        getStyleColor(appSettings, POST_BUTTON_TEXT_COLOR),
        getStyleColor(appSettings, TEXT_H1_COLOR),
        getStyleColor(appSettings, TEXT_H2_COLOR),
        getStyleColor(appSettings, TEXT_H3_COLOR),
        getStyleColor(appSettings, TEXT_H4_COLOR),
        getStyleColor(appSettings, TEXT_H5_COLOR),
        getStyleColor(appSettings, TEXT_H6_COLOR),
    ].filter((color) => Boolean(color));
    const hexColors = colors.map(toHexColor);
    const colorsToUse = Array.from(new Set(hexColors));
    return Object.fromEntries(colorsToUse.map((color, index) => [`textColor${index}`, { color, index }]));
};
export const getButtonColors = (appSettings) => {
    // colors used for ricos button templates
    const colors = {
        color1: getPresetColor(appSettings, 'color-1'),
        color7: getPresetColor(appSettings, 'color-7'),
        color8: getPresetColor(appSettings, 'color-8'),
    };
    return colors;
};
const isUniqueColor = (candidate, colors) => {
    return !colors.includes(candidate.toLocaleLowerCase());
};
export const saveUserColor = (getUniqueColors, submitColor) => (candidate) => {
    if (isUniqueColor(candidate, getUniqueColors())) {
        return submitColor(candidate.toLocaleLowerCase());
    }
};
export const getUniqueUserColors = (defaultColorsShema, userColors) => {
    const colorsToRemove = Object.values(defaultColorsShema).map(({ color }) => color);
    const colors = Array.from(new Set(userColors.map((col) => col.toLocaleLowerCase())));
    return colors.filter((col) => !colorsToRemove.includes(col));
};
export const mergeUserAndSiteColors = (userColors, colorSchema) => {
    const siteColors = Object.values(colorSchema);
    return [...siteColors, ...userColors].filter(Boolean);
};
const toHexColor = (color) => new TinyColor(color).toHexString();
export const styleSelectionPredicate = (colorScheme, richContent) => (inlineStyle) => (colorScheme[inlineStyle] && richContent.isHexColor(colorScheme[inlineStyle].color)) ||
    richContent.isHexColor(inlineStyle);
export const viewerCustomStyleFn = (colorScheme, richContent) => (inlineStyle) => {
    if (colorScheme[inlineStyle] && richContent.isHexColor(colorScheme[inlineStyle].color)) {
        return { color: colorScheme[inlineStyle].color };
    }
    if (richContent.isHexColor(inlineStyle)) {
        return { color: inlineStyle };
    }
    return {};
};
export const customStyleFn = (viewerCustomStyleCallback, richContent) => (inlineStyles) => inlineStyles.toArray().reduce((acc, inlineStyle) => ({
    ...acc,
    ...viewerCustomStyleCallback(inlineStyle, richContent),
}), {});
export const viewerCustomBackgroundStyleFn = (colorScheme, richContent) => (inlineStyle) => {
    const userColor = colorScheme?.[inlineStyle]?.color;
    if (richContent.isHexColor(userColor)) {
        return { backgroundColor: userColor };
    }
    if (richContent.isHexColor(inlineStyle)) {
        return { backgroundColor: inlineStyle };
    }
    return {};
};
//# sourceMappingURL=text-color-utils.js.map